import { defaultProps } from 'recompose';

import { defaultWidgetConfig } from 'constants';

import CommonButton from './CommonButton';

export default defaultProps({
  tooltipText: 'Voice',
  widget: defaultWidgetConfig,
})(CommonButton);
